import { Injectable } from '@angular/core';
import {
  MatLegacySnackBar as MatSnackBar,
  MatLegacySnackBarConfig as MatSnackBarConfig
} from '@angular/material/legacy-snack-bar';

@Injectable({
  providedIn: 'root'
})
export class AlertService {
  constructor(private snackBar: MatSnackBar) {}

  showMessage(message: string, action: string, type: 'success' | 'error' | 'warning', duration = 2000) {
    const config = new MatSnackBarConfig();
    config.horizontalPosition = 'end';
    config.verticalPosition = 'top';
    config.duration = duration;
    config.panelClass = [`${type}-snackbar`];
    this.snackBar.open(message, action, config);
  }

  showDefaultSuccessMessage(): void {
    this.showMessage('Your changes have been saved.', 'OK', 'success');
  }

  showDefaultErrorMessage(): void {
    this.showMessage('Something went wrong! Please, try again in a moment.', 'Error', 'error');
  }

  showDefaultErrorMessageForChoice(): void {
    this.showMessage('Something went wrong! Please, select one option.', 'Error', 'error');
  }
}
